import type { GetServerSidePropsContext } from 'next'

import VoceConsultaPage, { getServerSideProps as gSSP } from '@/pages/[...page]'

import '@/blocks/Premium/register'

export const getServerSideProps = (context: GetServerSidePropsContext) =>
  gSSP({ ...context, params: { ...context.params, page: ['voceconsulta'] } })

export default VoceConsultaPage
